import * as React from 'react';
import { ArticleHeading4 } from '@cian/ui-kit';
import { IconInfrastructureBank16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './BanksList.css';
import { IPromoBank } from '../../../../types/promos/bank';
import { ListItem } from '../ListItem';

interface IBanksListProps {
  banks: IPromoBank[];
}

export const BanksList: React.FC<IBanksListProps> = ({ banks }) => {
  return (
    <>
      <ArticleHeading4>Застройщик работает с банками</ArticleHeading4>
      <ul className={styles['container']}>
        {banks.map((bank, idx) => (
          <li key={idx} className={styles['item']}>
            <ListItem name={bank.name} logoUrl={bank.logo} defaultIcon={<IconInfrastructureBank16 />} />
          </li>
        ))}
      </ul>
    </>
  );
};
